import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';
import invariant from 'tiny-invariant';

interface ExportStateManagerContextType {
  isExporting: boolean;
  setIsExporting: Dispatch<SetStateAction<boolean>>;
  isSuccessful: boolean;
  setIsSuccessful: Dispatch<SetStateAction<boolean>>;
  triggerExport: () => void;
}

interface ExportStateManagerProps {
  children: React.ReactNode;
}

const ExportStateManagerContext = createContext<
  ExportStateManagerContextType | undefined
>(undefined);

export const ExportStateManager: React.FC<ExportStateManagerProps> = ({
  children,
}) => {
  const [isExporting, setIsExporting] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState(false);

  const triggerExport = useCallback(() => {
    setIsSuccessful(false);
    setIsExporting(true);
  }, []);

  return (
    <ExportStateManagerContext.Provider
      value={{
        isExporting,
        setIsExporting,
        triggerExport,
        isSuccessful,
        setIsSuccessful,
      }}
    >
      {children}
    </ExportStateManagerContext.Provider>
  );
};

export const useExportState = () => {
  const context = useContext(ExportStateManagerContext);

  invariant(
    context,
    'useExportState must be used within an ExportStateManagerContext'
  );

  return context;
};
